import { useState, useEffect, } from 'react'
import { Table, TableBody, Paper, Grid } from "@material-ui/core";
import { globalGetService } from '../../../utils/globalApiServices';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import { AuditListing, AuditHeader, fisAuditFilters } from '../components';
import { checkApiStatus } from '../../../utils';
import { EmptyCollection, PageLoader, } from '../../../shared_elements';
import FilterComponent from '../../../shared_elements/components/filter_component';
import STableLoader from '../../../shared_elements/components/skeleton_loader/STableLoader';
import Pagination from '../../../shared_elements/components/Pagination';
import { trackActivity } from '../../../utils/mixpanel';

function FisAudit() {
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [filter, setFilter] = useState({});
    const [fisAudit, setFisAudit] = useState({ list: [], pagination: {} });

    useEffect(() => {
        getFisAudit({ ...filter, per_page: 250 }, 'skeletonLoader')
        trackActivity('FIS-Audit - Airworthiness Management', {
            event_type: 'Page Visited',
            page_title: 'FIS-Audit Listing'
        });
    }, [])

    const getFisAudit = (query = {}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
        globalGetService(`camo/smbc_fis_integration_asset_summary/`, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setFisAudit({ list: response?.data?.data?.list || [], pagination: response?.data?.data?.pagination || {} });
                    delete query.page
                    delete query.per_page
                    delete query.sort
                    delete query.sort_by
                    setFilter(query)
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }

    const createSortHandler = (key) => {
        let sortQuery = { sort: key };
        if (sortInfo.sort === key) {
            sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort_by: 'asc' }
        }
        setSortInfo(sortQuery)
        getFisAudit({ ...filter, ...sortQuery, page: 1, per_page: fisAudit?.pagination?.per_page || 250 }, 'pageLoader');
    }
    const filterObj = Object.assign({}, filter, delete filter.sort, delete filter.sortInfo)
    return (
        <section className='camo-fleet-module'>
            {skeletonLoader ? <STableLoader count={10} /> :
                <>
                    <p style={{ textAlign: 'end', marginBottom: '5px' }}>
                        <span style={{ fontSize: '13px', background: '#FFFF96' }}>Every Monday UTC 00:00:SPARTA will push file into FIS</span>
                        <br />
                        <span style={{ fontSize: '13px', background: '#FFFF96' }}>Every Monday UTC 5:30: SPARTA will pull file from FIS</span>
                    </p>
                    <Paper variant='outlined' square style={{ padding: '5px 10px', marginBottom: "5px" }}>
                        <Grid container spacing={1} alignItems='center'>
                            <Grid item md={9}>
                                <div style={{ marginTop: "2px" }}>
                                    <FilterComponent
                                        filter={filterObj}
                                        filterMenu={fisAuditFilters}
                                        getResponseBack={(applyFilter) => getFisAudit({ ...applyFilter, page: 1, per_page: fisAudit?.pagination?.per_page || 20 }, 'pageLoader')}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                        <div style={{ height: !fisAudit?.list?.length ? 'auto' : `${window.innerHeight - 245}px`, overflow: 'auto' }}>
                            <Table className='mui-table-format' stickyHeader={true}>
                                <AuditHeader
                                    sortInfo={sortInfo}
                                    createSortHandler={createSortHandler}
                                />
                                <TableBody>
                                    {fisAudit?.list?.map((item, index) =>
                                        <AuditListing
                                            item={item}
                                            key={index}
                                        />
                                    )}
                                </TableBody>
                            </Table>
                            {!fisAudit?.list?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                        </div>
                        <Pagination
                            pagination={fisAudit?.pagination}
                            onChangePage={(event, newPage) => getFisAudit({ ...filter, page: newPage + 1, per_page: fisAudit?.pagination?.per_page || 250 }, 'pageLoader')}
                            onChangeRowsPerPage={(event) => getFisAudit({ ...filter, page: 1, per_page: event.target.value }, 'pageLoader')}
                        />
                    </Paper>
                </>
            }
            {isLoading ? <PageLoader /> : null}
        </section >
    )
}

export default withRouter(FisAudit)